import { client } from '../http';

export default {
  async generateInviteToken() {
    const response = await client.post('/api/invite-token');
    return response.data;
  },
};



// WEBPACK FOOTER //
// ./src/api/HansApi.js